export const TRANSLATIONS_STORAGE_KEY = "TRANSLATIONS";
export const TIMESTAMP_STORAGE_KEY = "TRANSLATIONS_TIMESTAMP";



// WEBPACK FOOTER //
// ./src/constants.js